import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EApiType } from 'common/enums/api-type.enum';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { getAdminEmissionHistoryService, getEmissionHistoryService } from '../services/emission.service';
import { TEmissionHistoryReqParams, TEmissionHistoryResData } from '../types/emission.types';

export const emissionQueryKeys = createQueryKeys(EQueryKeys.EmissionQueryKeys, {
  getEmissionHistory_MultiRole: (type: EApiType, counterpartyGUID: string, params?: TEmissionHistoryReqParams) => ({
    queryKey: ['admin-emission-history', type, counterpartyGUID, params],
    queryFn: (): Promise<TEmissionHistoryResData> => {
      if (type === EApiType.Admin) {
        return getAdminEmissionHistoryService(counterpartyGUID, params);
      }

      return getEmissionHistoryService(counterpartyGUID, params);
    },
  }),
});

